const sideNavItems = [
  {
    title: 'Utilities',
    icon: 'ToolIcon',
    enableFeature: true,
    children: [
      {
        title: 'API Gateway',
        route: 'api-gateway',
        enableFeature: true,
      },
    ],
  },
]

export default sideNavItems
